import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { ChallengeComputedState } from 'utils/challenges'
import { UserChallenge } from 'api/types'

interface Props {
  userChallenge: UserChallenge
  className?: string
}

export default function UserChallengeStatusBadge({ userChallenge, className }: Props): JSX.Element {
  if (userChallenge.computedState === ChallengeComputedState.LIVE) {
    return (
      <LiveBox className={className}>
        <FormattedMessage id="strings.live" />
      </LiveBox>
    )
  }
  if (userChallenge.computedState === ChallengeComputedState.UPCOMING) {
    return (
      <UpcomingBox className={className}>
        <FormattedMessage id="strings.upcoming" />
      </UpcomingBox>
    )
  }
  if (userChallenge.computedState === ChallengeComputedState.DRAFT) {
    return (
      <DraftBox className={className}>
        <FormattedMessage id="strings.draft" />
      </DraftBox>
    )
  }
  return <></>
}

const StatusBox = styled.div`
  display: inline-block;
  color: #fff;
  padding: 4px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  width: 100%;
  text-align: center;
`

const LiveBox = styled(StatusBox)`
  background: #1842a1;
`

const UpcomingBox = styled(StatusBox)`
  background: #f0ba00;
`

const DraftBox = styled(StatusBox)`
  background: #f00000;
`
